import styled from 'styled-components';

import ListItem from './ListItem';
import ListWrap from './ListWrap';

const Dropdown = styled.div`
  position: relative;
`;

Dropdown.ListItem = ListItem;
Dropdown.ListWrap = ListWrap;

export default Dropdown;
